import { IonContent, IonPage, IonSpinner } from '@ionic/react'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { useEffect } from 'react'
import { useSession } from '../../hooks/useSession'
import { useToast } from '../../hooks/useToast'

export const LogoutPage = () => {
  const { _ } = useLingui()
  const { logout } = useSession()
  const [presentToast] = useToast()

  // biome-ignore lint/correctness/useExhaustiveDependencies: run once on mount
  useEffect(() => {
    // Await so the graphcache wipe finishes before the logged-out toast/redirect
    void (async () => {
      await logout()
      presentToast({
        color: 'success',
        message: _(msg`You have been logged out`),
        duration: 3000,
      })
    })()
  }, [])

  return (
    <IonPage>
      <IonContent className='ion-padding ion-text-center'>
        <div style={{ marginTop: '40vh' }}>
          <IonSpinner name='crescent' />
          <p>{_(msg`Logging out...`)}</p>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default LogoutPage
